"use client";

import { Skeleton } from "@/components/ui/skeleton";

export function TableSkeleton() {
  return (
    <div className="w-full overflow-x-auto">
      <div className="flex justify-end mb-4">
        <Skeleton className="h-9 w-24" />
      </div>
      <div className="min-w-[800px]">
        <div className="rounded-md border">
          <div className="border-b">
            <div className="grid grid-cols-9 gap-4 p-4">
              {[...Array(9)].map((_, i) => (
                <Skeleton key={i} className="h-4 w-full" />
              ))}
            </div>
          </div>
          <div className="p-4">
            {[...Array(4)].map((_, rowIndex) => (
              <div key={rowIndex} className="grid grid-cols-9 gap-4 mb-4">
                {[...Array(9)].map((_, colIndex) => (
                  <Skeleton 
                    key={colIndex} 
                    className={`h-8 w-full ${colIndex === 1 ? 'flex items-center gap-2' : ''}`}
                  />
                ))}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
} 